import { render, staticRenderFns } from "./ym-sales.vue?vue&type=template&id=8e536046&scoped=true&"
import script from "./ym-sales.vue?vue&type=script&lang=js&"
export * from "./ym-sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e536046",
  null
  
)

export default component.exports